import { useEffect } from 'react';

import ClaimPromoGiftDialog from '../components/Dialogs/PromoDialogs/ClaimPromoGiftDialog/ClaimPromoGiftDialog';
import InvalidPromoDialog from '../components/Dialogs/PromoDialogs/InvalidPromoDialog/InvalidPromoDialog';
import { useStores } from '../stores/useStores';

export function useSetPromoPopup() {
  const { portalStore, promotionStore, featureManagerStore } = useStores();

  useEffect(() => {
    if (promotionStore.isPromoListenersEmpty) {
      promotionStore.addPromoListener((promotion) =>
        portalStore.openPortal(ClaimPromoGiftDialog, {
          promotion,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        }),
      );
    }

    if (promotionStore.isPromoErrorListenersEmpty) {
      promotionStore.addPromoErrorListener((errorCode) => {
        portalStore.openPortal(InvalidPromoDialog, {
          errorCode,
          beforeClose: () => {
            promotionStore.markPromotionFlowFinished();
            featureManagerStore.onDialogFinished('PromoGift');
          },
        });
      });
    }
  }, [portalStore, promotionStore, featureManagerStore]);
}
